/* eslint-disable react-hooks/exhaustive-deps */

import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';

import { getAllClientComments, getClientDetails, setClientId, setLoadingComplete } from 'modules/clients/clients.actions';
import { showToast } from 'modules/layout/layout.actions';
import CommentsAndNotesComponent from './commentsAndNotes.component';
import { fetchEnumerations } from 'modules/authorizations/utils/fetchDataDetailsService';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { GET_CLIENT_COMMENTS_FAILURE } from 'modules/clients/types';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { GET_CLIENT_DETAILS_FAILURE } from 'modules/clients/types';
import { getInternalUsers } from 'modules/common/common.actions';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

const ClientCommentsAndNotesView = props => {
  const { clientsInfo, serviceOptionId, viewMode, enumerations } = props;
  const clientId = +props.match.params.id;

    useEffect(() => {
      const fetchData = async () => {
        props.setClientId(clientId);

        if (!enumerations.allEnums) {
          await fetchEnumerations(props);
        }
        await props.getInternalUsers();
        if(!clientsInfo[clientId])
        {
            const resp = await props.getClientDetails(clientId);
            if (resp.type === GET_CLIENT_DETAILS_FAILURE) {
                props.showToast('Failed to retrieve data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
                return;
            }

            const commentsResp = await props.getAllClientComments(clientId);
    
            props.setLoadingComplete();

            if(commentsResp.type === GET_CLIENT_COMMENTS_FAILURE) {
                props.showToast('Failed to retrieve client comments, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR })
            }
        }
      };

      fetchData();
    }, []);

  const canReadClientComments = hasPermission(Permissions.Clients.Comments.Read);
  const canEditClientComments = hasPermission(Permissions.Clients.Comments.Edit);

  if (!canReadClientComments) {
    props.history.push('/');
    return null;
  }

  return (
    <>
      {!props.isLoading && clientsInfo && clientsInfo[clientId] && (
        <CommentsAndNotesComponent
          details={clientsInfo[clientId]}
          history={props.history}
          serviceOptionId={serviceOptionId}
          viewMode={viewMode}
          enumerations={props.enumerations}
          clientId={clientId}
          isReadOnly={!canEditClientComments}
          internalUsers={props.internalUsers}
        />
      )}
      {props.isLoading && <FullscreenSpinner />}
    </>
  );
};

ClientCommentsAndNotesView.propTypes = {
  clientsInfo: PropTypes.object,
  match: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  const { currentClientId, isLoading } = state.clients;
  const { internalUsers } = state.common;
  const clientsInfo = state.clients.clientsInfo;
  const enumerations = state.enumerations;

  return {
    clientsInfo,
    currentClientId,
    enumerations,
    isLoading,
    internalUsers
  };
};

export default compose(
  connect(mapStateToProps, {
    setLoadingComplete,
    showToast,
    getAllClientComments,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getClientDetails,
    setClientId,
    getInternalUsers
  })
)(ClientCommentsAndNotesView);
